import Cookie from 'js-cookie'
export default {
    state: {
        showMenu: false,
        searchBtn: false,
        isCollapse: true,  //控制菜单的展开还是收起 
        tabsList: [
            {
                path: "/",
                id: "home",
                label: "Home",
            }
        ],
        //面包屑数据
        menu: [],
        directory: ''
    },
    mutations: {
        changeDirectory(state, val) {
            state.directory = val;
        },
        // 修改菜单展开收起的方法
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        // 显示头部导航菜单
        setShowMenu(state) {
            state.showMenu = !state.showMenu;
        },
        openSearch(state) {
            state.searchBtn = !state.searchBtn;
        },
        // 更新面包屑数据
        selectMenu(state, val) {
            if (val.level == 2) {
                let firstItem = state.tabsList[0]; // 保存第一项
                state.tabsList.length = 0; // 清空数组
                state.tabsList.push(firstItem); // 将第一项重新添加回数组
                state.tabsList.push(val);
            } else if (val.node) {
                let breadcrumbs = collectAncestors(val.node);
                state.tabsList = state.tabsList.slice(0, 2);
                state.tabsList.push(...breadcrumbs);

            }

            function collectAncestors(node) {
                let ancestors = [];
                while (node && node.level > 0) { // level 为 0 表示这是根节点
                    ancestors.unshift({ label: node.data.label, id: node.data.id || node.data.articleId, isArticle: node.data.isArticle || '' });
                    node = node.parent;
                }
                return ancestors;
            }
        },
        // 删除指定的tag数据
        closeTag(state, item) {
            const index = state.tabsList.findIndex(val => val.name === item.name)
            state.tabsList.splice(index, 1)
        },
        // 设置menu的数据
        setMenu(state, val) {
            state.menu = val
            Cookie.set('menu', JSON.stringify(val))
        },
        // 动态注册路由
        // addMenu(state, router) {
        //     // 判断当前缓存中是否有数据
        //     if (!Cookie.get('menu')) return
        //     const menu = JSON.parse(Cookie.get('menu'))
        //     state.menu = menu
        //     // 处理动态路由的数据
        //     const menuArray = []
        //     menu.forEach(item => {
        //         if (item.children) {
        //             item.children = item.children.map(item => {
        //                 item.component = () => import(`../views/${item.url}`)
        //                 return item
        //             })
        //             menuArray.push(...item.children)
        //         } else {
        //             item.component = () => import(`../views/${item.url}`)
        //             menuArray.push(item)
        //         }
        //     });
        //     // 路由的动态添加
        //     menuArray.forEach(item => {
        //         router.addRoute('Main', item)
        //     })
        // },
        // 页面刷新时设置tabsList初始值
        resetTabsList(state) {
            state.tabsList = [
                {
                    path: "/",
                    id: "home",
                    label: "Home",
                    level: 1
                }
            ];
        }
    },
}